'use es6';

import { DragSource, DropTarget } from 'react-dnd';
import { findDOMNode } from 'react-dom';
import { pick } from 'underscore';
import { CUSTOM_WIDGET_FIELD_TABLE_ROW } from 'DesignData/enums/DragDropItemTypes';
import { STYLE_FIELD_TYPES, STYLE_FIELD_WITH_ALLOWED_CONTENT_TYPES } from 'DesignData/constants/StyleFields';
import * as CustomWidgetFieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { BEFORE, AFTER, AS_CHILD } from 'DesignData/enums/DragDropCustomWidgetFieldInsertTypes';

const getFieldsInGroup = group => {
  let childFields = [];

  if (group.children) {
    group.children.forEach(childField => {
      childFields.push(childField.type);

      if (childField.children) {
        childFields = childFields.concat(getFieldsInGroup(childField));
      }
    });
  }

  return childFields;
};

const canFieldDrop = (props, monitor) => {
  const currentField = monitor.getItem();

  if (currentField.field.type === CustomWidgetFieldTypes.GROUP && currentField.groupFieldChildrenList) {
    return props.isStyleTab ? currentField.groupFieldChildrenList.every(slug => STYLE_FIELD_WITH_ALLOWED_CONTENT_TYPES.includes(slug)) : !currentField.groupFieldChildrenList.some(slug => STYLE_FIELD_TYPES.includes(slug));
  }

  return props.isStyleTab ? STYLE_FIELD_WITH_ALLOWED_CONTENT_TYPES.includes(currentField.field.type) : !STYLE_FIELD_TYPES.includes(currentField.field.type);
};

export const fieldsTableRowDragSource = DragSource(CUSTOM_WIDGET_FIELD_TABLE_ROW, {
  beginDrag(props) {
    const newProps = pick(props, ['field', 'moveField', 'customWidgetId']);

    if (props.field.type === CustomWidgetFieldTypes.GROUP && props.field.children) {
      newProps.groupFieldChildrenList = getFieldsInGroup(props.field);
    }

    return newProps;
  },

  isDragging(props, monitor) {
    const draggedField = monitor.getItem() ? monitor.getItem().field : {};
    return props.field.id === draggedField.id;
  }

}, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
}));
export const fieldsTableRowDropTarget = DropTarget(CUSTOM_WIDGET_FIELD_TABLE_ROW, {
  hover(props, monitor, component) {
    const isJustOverThisField = monitor.isOver({
      shallow: true
    });
    const draggedFieldId = monitor.getItem().field.id;

    if (!isJustOverThisField || props.field.id === draggedFieldId) {
      return;
    }

    const {
      isOverBottom: prevIsOverBottom,
      isOverTop: prevIsOverTop
    } = component.state;
    const rect = findDOMNode(component).getBoundingClientRect();
    const yPercentage = (monitor.getClientOffset().y - rect.top) / rect.height;
    const isOverBottom = yPercentage > 0.5;
    const isOverTop = yPercentage < 0.5;

    if (prevIsOverBottom !== isOverBottom || prevIsOverTop !== isOverTop) {
      component.setState({
        isOverBottom,
        isOverTop
      });
    }
  },

  canDrop(props, monitor) {
    return canFieldDrop(props, monitor);
  },

  drop(props, monitor, component) {
    const {
      isOverBottom,
      isOverTop
    } = component.state;
    const {
      field,
      moveField,
      customWidgetId
    } = props;
    const isJustOverThisField = monitor.isOver({
      shallow: true
    });
    const draggedFieldId = monitor.getItem().field.id;

    if (!isJustOverThisField || field.id === draggedFieldId) {
      return;
    }

    let insertType = null;

    if (isOverBottom) {
      insertType = AFTER;
    } else if (isOverTop) {
      insertType = BEFORE;
    }

    moveField(customWidgetId, draggedFieldId, field.id, insertType);
  }

}, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver({
    shallow: true
  }),
  canDrop: monitor.canDrop()
}));
export const fieldGroupDropTarget = DropTarget(CUSTOM_WIDGET_FIELD_TABLE_ROW, {
  canDrop(props, monitor) {
    return canFieldDrop(props, monitor);
  },

  drop(props, monitor) {
    const {
      parentField,
      moveField,
      customWidgetId
    } = props;
    const isJustOverThisField = monitor.isOver({
      shallow: true
    });
    const draggedFieldId = monitor.getItem().field.id;

    if (!isJustOverThisField) {
      return;
    }

    moveField(customWidgetId, draggedFieldId, parentField.id, AS_CHILD);
  }

}, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver({
    shallow: true
  })
}));